//Responsive AI2html
import throttle from 'lodash.throttle';
import { findElementInShadowDom } from './render';

const RESIZER_CLASS_NAME = 'g-resizer-v3-init';

/** @type {Record<string, number>} **/
const WIDTHS_BY_ID = {};

/**
 * @param {HTMLElement} containerEl
 */
const resizer = (containerEl) => {
  const elements = Array.from(
    containerEl?.querySelectorAll('.g-artboard[data-min-width]') ?? []
  );

  elements.forEach(function (el) {
    const parent = el.parentNode;
    if (!parent) return;

    let width = WIDTHS_BY_ID[parent.id];
    if (!width) {
      // Width not found, retrieve from DOM and cache
      width = parent.getBoundingClientRect().width;
      WIDTHS_BY_ID[parent.id] = width;
    }

    const minWidth = parseInt(el.getAttribute('data-min-width') || '0');
    const maxWidth = parseInt(el.getAttribute('data-max-width') || '0');
    const nextMinWidth = minWidth + 1;
    const nextMaxWidth = maxWidth + 1;

    if (nextMinWidth <= width && (nextMaxWidth >= width || maxWidth === null)) {
      el.style.display = 'block';
    } else {
      el.style.display = 'none';
    }
  });
};

/**
 * @param {string} elementSelector
 */
export const resize = (elementSelector) => {
  if (!elementSelector) {
    console.error('No element selector provided');
  }

  const container = findElementInShadowDom(elementSelector);
  if (!container) {
    console.error(
      `Unable to find container element with selector: ${elementSelector}`
    );
    return;
  }

  if (container.className.indexOf(RESIZER_CLASS_NAME) > -1) {
    console.error(
      `Resizer already found for element ${elementSelector}, exiting`
    );
    return;
  }

  container.className += ` ${RESIZER_CLASS_NAME}`;

  const resizerAction = () => {
    // @ts-ignore
    resizer(container);
  };

  // Resize immediately
  document.addEventListener('DOMContentLoaded', resizerAction);

  // Trigger resizer when viewport changes
  window.addEventListener('resize', throttle(resizerAction, 200));
};
